import React, { useContext, useState } from 'react'
import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'
import axios from 'axios'
import { useMutation, useQuery } from '@apollo/client'
import { GET_BILLING_HISTORY_BY_BG_ACCOUNT } from '../../../graphql/query'
import { usePlan } from '../../../context/PlanContext'
import UserContext from '../../../context/UserContext'
import { UPDATE_PDF_LOCATION } from '../../../graphql/mutation'
pdfMake.vfs = pdfFonts as unknown as typeof pdfMake.vfs

const Index = () => {
  const { currentPlan } = usePlan()
  const { data: data1, loadingUser, errorLoadingUser } = useContext(UserContext)
  const [currentPage, setCurrentPage] = useState(1)
  const accountPerPage = 10
  const accountPerPageOffset = (currentPage - 1) * accountPerPage
  const { loading, error, data } = useQuery(GET_BILLING_HISTORY_BY_BG_ACCOUNT, {
    variables: {
      input: {
        limit: accountPerPage,
        offset: accountPerPageOffset,
        bgAccountId: currentPlan?.bgAccountId
      }
    },
    context: {
      headers: {
        'access-control-allow-methods': 'AdminPermission'
      }
    },
    skip: !currentPlan?.bgAccountId // Skip the query if bgAccountId is not present
  })

  const [updatePdfLocation] = useMutation(UPDATE_PDF_LOCATION, {
    refetchQueries: [
      {
        query: GET_BILLING_HISTORY_BY_BG_ACCOUNT,
        variables: {
          input: {
            offset: 0,
            limit: 10,
            bgAccountId: currentPlan?.bgAccountId
          }
        },
        context: {
          headers: {
            'access-control-allow-methods': 'AdminPermission'
          }
        }
      }
    ],
    context: {
      headers: {
        'access-control-allow-methods': 'AdminPermission'
      }
    }
  })

  if (error || errorLoadingUser) {
    console.log(error)
  }
  if (loading || loadingUser) {
    return <>Loading...</>
  }
  if (data) {
    console.log(data)
  }

  const billingData = data?.getBillingHistoryByBgAccount?.allBillingHistory || []
  const totalCount = data?.getBillingHistoryByBgAccount?.totalCount

  const generatePdf = async (invoiceData: any) => {
    console.log(invoiceData)
    if (invoiceData?.pdfLocation === null) {
      const docDefinition: any = {
        content: [
          {
            table: {
              widths: ['*'],
              body: [
                [{ text: 'BOTGO', style: 'header', alignment: 'left' }],
                [
                  {
                    style: 'companyDetails',
                    table: {
                      widths: ['*'],
                      body: [
                        [{ text: 'Botgo Technologies Private Limited', alignment: 'right' }],
                        [{ text: 'info@botgotechpvtltd.com', alignment: 'right' }],
                        [{ text: '+91 888555XXXX', alignment: 'right' }],
                        [
                          {
                            text: 'B-67, Sector 67, Noida, 201301, Delhi-NCR, India',
                            alignment: 'right'
                          }
                        ]
                      ]
                    },
                    layout: 'noBorders'
                  }
                ]
              ]
            },
            layout: 'noBorders',
            style: 'brandSection'
          },
          { text: '\n' },
          {
            canvas: [
              { type: 'line', x1: 0, y1: 0, x2: 500, y2: 0, lineWidth: 0.1, strokeColor: '#888' }
            ]
          },
          { text: '\n' }, // Add some space after the line
          {
            columns: [
              {
                style: 'invoiceInfo',
                table: {
                  widths: ['*'],
                  body: [
                    [{ text: `Invoice No: ${invoiceData?.invoiceNumber}`, style: 'heading' }],
                    [{ text: `Plan Start Date: ${invoiceData?.planStartDate}` }],
                    [{ text: `Expiry Date: ${invoiceData?.expiryDate}` }],
                    [{ text: `Email Address: ${data1?.getUserById?.email}` }]
                  ]
                },
                layout: 'noBorders'
              },
              {
                style: 'customerDetails',
                table: {
                  widths: ['*'],
                  body: [
                    [{ text: `Full Name: ${data1?.getUserById?.name}` }],
                    [{ text: `Address: xxxxxx` }],
                    [{ text: `Phone Number:${data1?.getUserById?.contactNumber}` }]
                  ]
                },
                layout: 'noBorders'
              }
            ]
          },
          { text: '\n' },
          {
            canvas: [
              { type: 'line', x1: 0, y1: 0, x2: 500, y2: 0, lineWidth: 0.1, strokeColor: '#888' }
            ]
          },
          { text: '\n' }, // Add some space after the line
          { text: 'Ordered Items', style: 'subheader' },
          {
            table: {
              widths: ['35%', '35%', '35%', '35%'],
              body: [
                [
                  { text: 'Plan Name', style: 'tableHeader' },
                  { text: 'Package Amount', style: 'tableHeader' },
                  { text: 'Grand Total', style: 'tableHeader' }
                ],
                [
                  { text: ` ${invoiceData?.packageName}`, style: 'tableCell' },
                  { text: `${invoiceData?.packageAmount}`, style: 'tableCell' },
                  { text: '', style: 'tableCell' }
                ],
                [
                  { text: 'Sub Total', colSpan: 2, alignment: 'right', style: 'tableCell' },
                  {},
                  { text: `${invoiceData?.amountPaid}`, style: 'tableCell' }
                ],
                // [
                //   { text: 'Tax Total %1X', colSpan: 2, alignment: 'right', style: 'tableCell' },
                //   {},
                //   { text: '2', style: 'tableCell' }
                // ],
                [
                  { text: 'Grand Total', colSpan: 2, alignment: 'right', style: 'tableCell' },
                  {},
                  { text: `${invoiceData?.amountPaid}`, style: 'tableCell' }
                ]
              ]
            },
            layout: {
              hLineWidth: (i: any, node: any) => 1,
              vLineWidth: (i: any, node: any) => 1,
              hLineColor: (i: any, node: any) => '#dee2e6',
              vLineColor: (i: any, node: any) => '#dee2e6',
              paddingLeft: (i: any, node: any) => 8,
              paddingRight: (i: any, node: any) => 8,
              paddingTop: (i: any, node: any) => 8,
              paddingBottom: (i: any, node: any) => 8
            }
          },
          { text: '\n' },
          {
            canvas: [
              { type: 'line', x1: 0, y1: 0, x2: 500, y2: 0, lineWidth: 0.1, strokeColor: '#888' }
            ]
          },
          { text: '\n' }, // Add some space after the line
          { text: 'Terms and Conditions', style: 'subheader' },
          { text: '1. All subscriptions are non-refundable once activated.' },
          {
            text: '2. The subscription plan will automatically renew unless canceled before the renewal date.'
          },
          {
            text: '3. Users must adhere to the acceptable use policy outlined in the terms of service.'
          },
          { text: '4. Any disputes shall be resolved under the jurisdiction of Delhi, India.' },
          { text: '5. For support, please contact info@botgotechpvtltd.com.' },
          { text: '\n' },
          {
            canvas: [
              { type: 'line', x1: 0, y1: 0, x2: 500, y2: 0, lineWidth: 0.1, strokeColor: '#888' }
            ]
          },
          { text: '\n' }, // Add some space after the line
          { text: '© 2024 Botgo Technologies Pvt Ltd.', style: 'footer' },
          { text: 'https://botgo.io/', style: 'footerLink', link: 'https://botgo.io/' }
        ],
        styles: {
          header: {
            fontSize: 22,
            bold: true,
            color: '#fff',
            margin: [40, 20, 0, 18],
            alignment: 'right'
          },
          brandSection: {
            fillColor: '#0d1033',
            color: '#fff'
          },
          heading: { fontSize: 14, bold: true, color: '#262626' },
          companyDetails: { margin: [0, -70, 20, 30] },
          subheader: { fontSize: 12, bold: true, margin: [0, 5, 0, 8], color: '#262626' },
          invoiceInfo: { fontSize: 12, margin: [0, 5, 0, 5] },
          customerDetails: { fontSize: 12, margin: [0, 5, 0, 5] },
          tableHeader: { bold: true, fillColor: '#f2f2f2', alignment: 'center' },
          tableCell: { alignment: 'center', verticalAlign: 'middle', padding: 8 },
          footer: {
            fontSize: 12,
            italics: true,
            color: '#777',
            margin: [0, 20, 0, 0],
            alignment: 'center'
          },
          footerLink: { fontSize: 12, italics: true, color: '#777', alignment: 'center' }
        }
      }

      pdfMake.createPdf(docDefinition).getBlob(async (blob) => {
        // Pass the blob to the getFileURL function
        const file = new File([blob], `${invoiceData.amountPaid}.pdf`, { type: 'application/pdf' })
        await getFileURL(file, invoiceData?.invoiceNumber)
      })
    } else {
      // Download the PDF from the provided URL
      const link = document.createElement('a')
      link.href = invoiceData.pdfLocation
      link.download = 'Invoice.pdf'
      link.click()
    }
  }

  async function getFileURL(file: any, invoice: any) {
    console.log(file)
    try {
      const fileUploadEndpoint = process.env.REACT_APP_FILE_UPLOAD_URL

      if (!fileUploadEndpoint) {
        console.error('File upload endpoint is not defined.')
        return
      }
      console.log(file)

      let response = await axios.post(fileUploadEndpoint, {
        files: [{ fileName: file.name, mimeType: file.type }]
      })

      const uploadURL = response.data[0].uploadURL

      // Send file to uploadURL after the url is created in s3
      await axios.put(uploadURL, file)
      console.log(response?.data[0]?.url)

      updatePdfLocation({
        variables: {
          input: {
            invoiceNumber: String(invoice),
            pdfLocation: response?.data[0]?.url
          }
        }
      })
        .then((res: any) => {
          console.log(res)
          const link = document.createElement('a')
          link.href = response?.data[0]?.url
          link.download = 'Invoice.pdf'
          link.click()
        })
        .catch((err) => {
          console.log(err)
        })
    } catch (err) {
      console.log(err)
    }
  }

  const getStatusClass = (status: string) => {
    switch (status) {
      case 'ACTIVE':
        return 'badge badge-light-success'
      case 'PENDING':
        return 'badge badge-light-warning'
      default:
        return 'badge badge-light-danger'
    }
  }

  const renderTableRows = (data: any) => {
    return data.map((row: any, index: any) => (
      <tr key={row.invoiceNumber}>
        <td>
          <span className='badge badge-light-danger fs-7 fw-bold btn-active-light-primary'>
            <i className='bi bi-filetype-pdf fs-2' style={{ color: 'red' }}></i>
          </span>
          {row.invoiceNumber}
        </td>
        <td>{row.amountPaid}</td>
        <td>{row.paymentDate}</td>
        <td>{row.packageName || 'Not mentioned'}</td>
        <td>
          <div className={getStatusClass(row.packageStatus)}>{row.packageStatus}</div>
        </td>

        <td>
          <button className='btn btn-sm my-1' onClick={() => generatePdf(row)}>
            <i className='bi bi-cloud-arrow-down fs-2'></i>
            Download
          </button>
        </td>
      </tr>
    ))
  }
  const totalPages = Math.ceil(totalCount / accountPerPage)

  const paginate = (pageNumber: number) => {
    setCurrentPage(pageNumber)
  }

  const nextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage((prevPage) => prevPage + 1)
    }
  }

  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1)
    }
  }

  // Generate snake handle pagination numbers
  const generatePaginationNumbers = () => {
    let numbers: number[] = []
    const maxVisibleNumbers = 5 // Maximum visible pagination numbers

    if (totalPages <= maxVisibleNumbers) {
      // If total pages are less than or equal to max visible numbers, show all
      for (let i = 1; i <= totalPages; i++) {
        numbers.push(i)
      }
    } else {
      const middleIndex = Math.ceil(maxVisibleNumbers / 2) // Middle index of the pagination numbers
      let startPage = currentPage - middleIndex + 1
      let endPage = currentPage + middleIndex - 1

      if (startPage < 1) {
        // If start page is less than 1, adjust start and end page accordingly
        endPage = startPage + maxVisibleNumbers - 1
        startPage = 1
      } else if (endPage > totalPages) {
        // If end page is greater than total pages, adjust start and end page accordingly
        startPage = endPage - maxVisibleNumbers + 1
        endPage = totalPages
      }

      for (let i = startPage; i <= endPage; i++) {
        numbers.push(i)
      }
    }

    return numbers
  }
  return (
    <div style={{ marginTop: '40px' }}>
      <div className=''>
        <div className='card-header '>
          <div className=''>
            <h3>Billing History({totalCount || 0})</h3>
            <div className='fs-6 fw-semibold text-gray-500'>
              See history of your payment plan invoice
            </div>
          </div>
        </div>
        <div className='tab-content'>
          <div id='kt_billing_months' className='card-body p-0 tab-pane fade show active'>
            <div className='table-responsive'>
              <table className='table table-row-bordered align-middle gy-4 gs-9'>
                <thead className='border-bottom border-gray-200 fs-6 fw-bold bg-light bg-opacity-75'>
                  <tr>
                    <td className='min-w-100px'>Invoice</td>
                    <td className='min-w-100px'>Amount</td>
                    <td className='min-w-100px'>Billing Date</td>
                    <td className='min-w-100px'>Plan</td>
                    <td className='min-w-100px'>Status</td>
                    <td className='min-w-100px'>Download Invoice</td>
                  </tr>
                </thead>
                <tbody className='fw-semibold text-gray-600'>{renderTableRows(billingData)}</tbody>
              </table>
            </div>
            <div className='row m-2'>
              <div className='col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start dt-toolbar'></div>
              <div className='col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end'>
                <div className='dt-paging paging_simple_numbers'>
                  <div
                    className='dataTables_paginate paging_simple_numbers'
                    id='kt_table_users_paginate'
                  >
                    <ul className='pagination pb-2'>
                      <li
                        className={`paginate_button page-item ${
                          currentPage === 1 ? 'disabled' : ''
                        }`}
                      >
                        <button
                          type='button'
                          aria-controls='kt_table_users'
                          data-dt-idx='0'
                          className='btn primary page-link'
                          onClick={prevPage}
                        >
                          <i className='previous'></i>
                        </button>
                      </li>
                      {generatePaginationNumbers().map((pageNumber) => (
                        <li
                          key={pageNumber}
                          className={`paginate_button page-item ${
                            currentPage === pageNumber ? 'active' : ''
                          }`}
                        >
                          <button
                            type='button'
                            aria-controls='kt_table_users'
                            data-dt-idx={pageNumber}
                            className='btn primary page-link'
                            onClick={() => paginate(pageNumber)}
                          >
                            {pageNumber}
                          </button>
                        </li>
                      ))}
                      <li
                        className={`paginate_button page-item ${
                          currentPage === totalPages ? 'disabled' : ''
                        }`}
                      >
                        <button
                          type='button'
                          aria-controls='kt_table_users'
                          data-dt-idx='0'
                          className='btn primary page-link'
                          onClick={nextPage}
                        >
                          <i className='next'></i>
                        </button>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Index
